import { RootState } from '@beam-app/types';
import { EquipmentsMap } from '@store/machines/equipmentsPicker.schema';
import { pick } from '@utils/pick';
import { SHARED_FIELDS } from '../OnBoardingModal.utils';
import { LambdaTags } from './PatchMassEditLambda';
import { mergeFields } from './mergeFields';
import { GlobalEquipment } from '../types';

const EXCLUDE_GLOBAL = ['id', 'studioId', 'serial'] as const;
type IExcludeGlobal = typeof EXCLUDE_GLOBAL[number];
type ISharedFields = typeof SHARED_FIELDS[number];
type IOmitted = Exclude<ISharedFields, IExcludeGlobal>;
const SHARED = SHARED_FIELDS.filter(
  (key): key is IOmitted => !EXCLUDE_GLOBAL.includes(key as IExcludeGlobal),
);
export function mapGlobalToEquipments(
  value: Partial<GlobalEquipment>,
  equipments: EquipmentsMap,
  knownData: RootState['knownData'],
  tagsDiff: LambdaTags,
): EquipmentsMap {
  const newEntries = Array.from(equipments.entries(), entry => {
    const [, old] = entry;
    const shared = pick(value, SHARED);
    let {
      equipmentStatus,
      manufacturerImg,
      manufacturerName,
      product,
      user,
      fields,
      tags,
    } = old;
    if (value.equipmentStatusId) {
      equipmentStatus = knownData.knownStatuses[value.equipmentStatusId];
    }
    if (value.productId) {
      ({
        manufacturerImg = manufacturerImg,
        manufacturerName = manufacturerName,
        ...product
      } = knownData.knownProducts[value.productId]);
    }
    if (value.userId) {
      user = knownData.knownUsers[value.userId];
    }
    if (value.tagsId) {
      let tagsCopy = [...tags];
      tagsDiff.forEach(diff => {
        if (diff.action === 'ADD') {
          const without = tagsCopy.filter(tag => tag.id !== diff.tagId);
          tagsCopy = without.concat(knownData.knownTags[diff.tagId]);
        }
        if (diff.action === 'REMOVE') {
          tagsCopy = tagsCopy.filter(tag => tag.id !== diff.tagId);
        }
        tags = tagsCopy;
      });
      // tags = value.tagsId.map(tagId => knownData.knownTags[tagId]);
    }
    if (value.customFields) {
      fields = mergeFields(fields, value.customFields);
    }
    const newEquipment = {
      ...old,
      ...shared,
      equipmentStatus,
      manufacturerImg,
      manufacturerName,
      product,
      user,
      fields,
      tags,
    };
    return [old.id, newEquipment] as const;
  });
  const newMap = new Map(newEntries);
  return newMap;
}
